<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-12">
						<h4 class="mt-2 mb-4 pb-2 pt-2"><span class="green">SME:</span> {{ sme_data.first_name }} {{ sme_data.last_name }}</h4>
					</div><!--col-->
				</div><!--row-->
					
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-5">
				<form @submit.prevent="onSubmit">
					<label class="d-block mb-2 text-uppercase">Details</label>
					<div  class="lightgray-content p-3 rounded mb-4">
						<div class="form-group input-content">
							<label>Email</label>
							<input placeholder="Email" type="text" v-model="sme_data.email" class="form-control" v-validate="'required'" name="email">
							<span class="input-error-msg">{{ errors.first('email') }}</span>
						</div>
						<div class="form-group input-content">
							<label>First name</label>
							<input placeholder="First name" type="text" v-model="sme_data.first_name" class="form-control" v-validate="'required'" name="first_name">
							<span class="input-error-msg">{{ errors.first('first_name') }}</span>
						</div>
						<div class="form-group input-content">
							<label>Last name</label>
							<input placeholder="Last name" type="text" v-model="sme_data.last_name" class="form-control" v-validate="'required'" name="last_name">
							<span class="input-error-msg">{{ errors.first('last_name') }}</span>
						</div>
					</div>
					<div class="text-right">
						<button type="submit" class="button">Submit</button>
					</div>
				</form>
			</div><!--col-->
			<div class="col-12 col-xl-5">
				<label class="d-block mb-2 text-uppercase">Associated programs</label>
			    <div class="table-responsive">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="green-content">Name</th>
								<th class="green-content">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in sme_data.courses" >
								<td>{{ item.name }}</td>
								<td>
									
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				
				<div class="row justify-content-between ">
					<div class="col-12 col-lg-6">
						<span>Showing {{ courses_table.from }} to {{ courses_table.to }} of {{ courses_table.total_rows }}</span>
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="courses_table.total_rows" v-model="courses_table.current_page" :per-page="courses_table.per_page" @change="setPageCourses">
		    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
	</div>
</template>


<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			sme_data : {
				email : '',
				first_name : '',
				last_name : '',
				dob : '',
				courses : []
			},
			courses_table : {
				current_page : 0,
				total_rows : 0,
				per_page : 0,
				from : 0,
				to : 0
			},
		}
	},

	created : function(){
		this.getSME();
	},

	methods : {
		getSME : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getSME', params).then((res) => {
				this.sme_data = res.data.data;
			}).catch((error) => {	
				console.log(error);
			})
		},
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					this.$store.dispatch('editSME', this.sme_data).then((res) => {
						console.log("OK", res);
						this.$router.push({ name : 'admin.smes.index' });
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},

		getCourses : function(){

			var params = {
				filters : {
					page : this.courses_table.current_page
				},
				id : this.id
			}

			this.$store.dispatch('getSMECourses', params).then((res) => {
				this.sme_data.courses = res.data.data;

				this.courses_table.current_page = res.data.meta.current_page;
				this.courses_table.total_rows = res.data.meta.total;
				this.courses_table.per_page = res.data.meta.per_page;
				this.courses_table.from = res.data.meta.from;
				this.courses_table.to = res.data.meta.to;
			});
		},
		setPageCourses : function(page){
			this.courses_table.current_page = page;

			this.getCourses();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/smes/AdminSMEDetailComponent.vue